// 检查是否包含数字和英文逗号
export const validateText = (text: string, allowEmpty = false) => {
  if (allowEmpty && !text) {
    return true;
  }
  const hasConsecutiveCommas = /,,/.test(text);
  const hasStartEndCommas = /^,|,$/.test(text);
  return !hasConsecutiveCommas && !hasStartEndCommas;
};
